<div
  class="relative size-[10.375rem] sm:size-[16.875rem] md:size-[15.1875rem] lg:size-[16.5rem] rounded-[0.25rem] overflow-hidden cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-(--p-primary-500) focus-visible:ring-offset-2"
  [ngClass]="styleClass()"
  role="button"
  tabindex="0"
  pRipple
  (click)="onSelect()"
  (keydown.enter)="onSelect()">
  <img [src]="picture().imageUrl" [style.transform]="'rotate(' + currentRotation() + 'deg)'" alt="" class="w-full h-full object-cover" />

  <div
    class="absolute inset-x-0 bottom-0 pt-[1.5rem] pr-[0.75rem] pb-[0.875rem] md:pb-[0.75rem]"
    style="background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);">
    <div class="font-[500] text-[0.6875rem] leading-[150%] tracking-[0%] text-right text-(--p-white)">
      {{ modifiedAt() }}
    </div>
  </div>
</div>
